import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import { createFetchErrorMessage } from 'utils/api/ApiClient';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from 'react-toastify';
import Api from 'utils/api/Api';
import { Editor } from 'app/components/Editor';
import { characterCount } from 'utils/utils';


export const UserBookEpisodeForm = ({ initialData }) => {
    const navigate = useNavigate();
    // const location = useLocation();

    const { school, book, episode } = useParams();
    const [subject, setSubject] = useState('');
    const [content, setContent] = useState('');
    const [contentLength, setContentLength] = useState(0);

    const queryClient = useQueryClient();

    useEffect(() => {
        setSubject(initialData.subject);
        setContent(initialData.content);
        const tempLength = characterCount(initialData.content);
        setContentLength(tempLength);
    }, [initialData]);

    // --------------------------- 임시저장
    const episodeTemp = useQuery({
        queryKey: ['userbook/episode/temp', book],
        queryFn: () => Api.get(`/api/userBook/episode/temp/${book}`),
        refetchOnMount: 'always',
    });

    const sotreTempMutate = useMutation({
        mutationFn: (data) => Api.post('/api/userBook/episode/temp/store', data),
        onSuccess: (res) => {
            queryClient.invalidateQueries({ queryKey: ['userbook/episode/temp', book] });
            toast.success("임시저장 작품은 30일 이후 자동삭제됩니다.");
        },
        onError: (err) => {
            toast.error(createFetchErrorMessage(err).message);
        }
    });

    // 임시저장
    const onStoreTemp = () => {
        if (sotreTempMutate.isPending) return;
        if (!window.confirm("임시저장을 하겠습니까?")) return;
        let data = { book_id: book, subject, content };
        sotreTempMutate.mutate(data);
    }

    // 임시저장 불러오기
    const onLoadTemp = () => {
        if (episodeTemp.isLoading) return;
        if (!window.confirm("임시저장을 불러 오겠습니까?")) return;
        if (episodeTemp.data?.data.bookId !== Number(book)) {
            toast.error('임시저장 정보와 작품 정보가 다릅니다.');
            return;
        }
        setSubject(episodeTemp.data?.data.subject);
        setContent(episodeTemp.data?.data.content);
        const tempLength = characterCount(episodeTemp.data?.data.content);
        setContentLength(tempLength);
    }


    // -------------------------- 저장
    const episodeStoreMutate = useMutation({
        mutationFn: (data) => Api.post('/api/userBook/episode/store', data),
        onSuccess: (res) => {
            queryClient.invalidateQueries({ queryKey: ['userbook/episode', String(res.data)] });
            queryClient.invalidateQueries({ queryKey: ['userbook/episode/list', book] });

            navigate({ pathname: `/${school}/userbook/episode/view/${res.data}`, search: '' });
        },
        onError: (err) => {
            toast.error(createFetchErrorMessage(err).message);
        }
    })

    const onChangeTitle = (e) => {
        const tempTitle = e.target.value.replace(/\s{2,}/gi, " ");
        setSubject(tempTitle);
    };

    const onSave = () => {
        if (episodeStoreMutate.isPending) return;

        if (subject === '') {
            toast.error('제목을 입력해주세요.');
            return;
        }
        if (content === '') {
            toast.error('내용을 입력해주세요.');
            return;
        }

        if (contentLength < 300) {
            toast.error('300자 이상으로 작성해주세요.');
            return;
        }
        episodeStoreMutate.mutate({ id: episode, book_id: book, subject, content, });
    }


    return (
        <div className="inner">
            <div className="write_box">
                <input type="text" maxLength="40" name="subject" className="subject title" placeholder="부제목을 입력해주세요." value={subject} onChange={onChangeTitle} />
                <div className="fiction_box">
                    <Editor
                        initialData={initialData.content}
                        data={content}
                        onChange={(e, editor) => {
                            const tempData = editor.getData()
                            const tempLength = characterCount(tempData);
                            setContent(tempData);
                            setContentLength((prev) => {
                                if (tempLength - prev > 10) {
                                    window.location = `/${school}/errorPaste?type=userbook`;
                                    return 0;
                                }
                                return tempLength;
                            });
                        }} />
                    <div className="text-right">{contentLength} 자</div>
                </div>

                <div className="controls">
                    {episode === undefined && <button className="btn _gray floatL" onClick={onStoreTemp} >임시저장</button>}
                    {episode === undefined && episodeTemp.isSuccess && episodeTemp.data?.data && <button className="btn _gray floatL" onClick={onLoadTemp} >임시저장불러오기</button>}

                    &nbsp;&nbsp;
                    <button className="btn _blue floatR" onClick={onSave}>등록하기</button>
                    <Link className="btn light_gray floatR" to={`/${window.schoolCode}/userbook/view/${book}`}>취소</Link>
                </div>
            </div>
        </div>
    );
}